import { z } from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { AddressFormSchema } from '../../AddressService/schemas';

const GeneralRecognitionFormSchemaWithAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  cnpj: z.string().optional(),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  vehicleTags: z.array(z.string()).nullish(),
  accessCardTags: z.array(z.string()).nullish(),
  recognitionGroupIds: z.number().array().nullable(),
  facialControllerIds: z.number().array().nullable(),
  isAddress: z.literal(true),
  address: AddressFormSchema,
  file: z.union([z.instanceof(Blob), z.string()]).optional(),
  type: z.string().nullish(),
  uc: z.array(z.string()).nullish(),
});

const GeneralRecognitionFormSchemaWithoutAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  cnpj: z.string().optional(),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  vehicleTags: z.array(z.string()).nullish(),
  accessCardTags: z.array(z.string()).nullish(),
  recognitionGroupIds: z.number().array().nullable(),
  facialControllerIds: z.number().array().nullable(),
  deviceGroupIds: z.number().array().nullable(),
  isAddress: z.literal(false),
  address: z.null(),
  file: z.union([z.instanceof(Blob), z.string()]).optional(),
  classId: z.number().array().nullish(),
  type: z.string().nullish(),
  uc: z.array(z.string()).nullish(),
});

export const GeneralRecognitionFormSchema = z
  .discriminatedUnion('isAddress', [
    GeneralRecognitionFormSchemaWithAddress,
    GeneralRecognitionFormSchemaWithoutAddress,
  ])
  .superRefine((data, ctx) => {
    if (
      (data.recognitionGroupIds?.length ?? 0) === 0 &&
      (data.facialControllerIds?.length ?? 0) === 0
    ) {
      // ctx.addIssue({
      //   path: ['recognitionGroupIds'],
      //   code: z.ZodIssueCode.custom,
      //   message: 'Selecione ao menos um grupo ou/e um controlador facial.',
      // });
      //
      // ctx.addIssue({
      //   path: ['facialControllerIds'],
      //   code: z.ZodIssueCode.custom,
      //   message: 'Selecione ao menos um grupo ou/e um controlador facial.',
      // });
    }

    if (data.validUntil) {
      const validUntil = new Date(data.validUntil);
      const now = new Date();

      now.setTime(0);
      validUntil.setTime(0);

      if (validUntil.getTime() < now.getTime()) {
        ctx.addIssue({
          path: ['validUntil'],
          code: z.ZodIssueCode.custom,
          message:
            'A data de validade da face não pode ser anterior à data atual.',
        });
      }
    }
  });
